export enum StorageKey {
  RemovedPromoCookies = 'removed_promo_cookies',
  RemovedPromoBanners = 'removed_promo_banners',
  ConfirmCodeTimerEndDate = 'confirm_code_timer_end_date',
  IsSignInModalAsked = 'is_sign_in_modal_asked',
  AlreadyAskedConvergenceOrderList = 'already_asked_convergence_order_list',
  AccessToken = 'access_token',
  RefreshToken = 'refresh_token',
  OrderId = 'order_id',
}

export const getFromLocalStorage = (key: StorageKey) => {
  const data = localStorage.getItem(key);
  if (!data) return undefined;
  try {
    const val = JSON.parse(data);
    return val;
  } catch (e) {
    return data;
  }
};

export const setOnLocalStorage = (
  data: string | number | Record<string, any> | any[],
  key: StorageKey
) => {
  const dataToSave =
    typeof data === 'string' || typeof data === 'number'
      ? data
      : JSON.stringify(data);
  localStorage.setItem(key, String(dataToSave));
};

export const removeFromLocalStorage = (key: StorageKey) => {
  localStorage.removeItem(key);
};

export const clearLocalStorage = () => {
  localStorage.clear();
};
